import { EDIT_CAMPAIGN } from "../actions/campaignActions";

const initialState = {};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EDIT_CAMPAIGN:
      return { ...state, ...payload };
    default:
      return state;
  }
};
export default reducer;
